import { Controller, useForm } from 'react-hook-form';

import { useGetCategoriesQuery } from '~entities/product';

import { phMoneyProps } from '~shared/constants';
import { combineValidators } from '~shared/lib/combine-validators';
import { plural } from '~shared/lib/plural';
import { validators } from '~shared/validators';

import Button from '@breeze-platform-ui/button';
import {
  Checkbox,
  Input,
  InputCount,
  InputMoney,
  Select,
} from '@breeze/rhf-adapters';

import type { ItemFormValue } from '../order-form';

type Props = {
  onDone: (item: ItemFormValue) => void;
  allowsUsedItems: boolean;
};
export const ItemForm = ({ onDone, allowsUsedItems }: Props) => {
  const { control, handleSubmit, watch } = useForm<ItemFormValue>({
    mode: 'all',
    defaultValues: { quantity: 1 },
  });
  const { data: categories } = useGetCategoriesQuery();

  const categoriesOptions = categories
    ?.map((category) => ({
      title: category.displayName,
      value: category.code,
    }))
    .concat({ title: 'Shipping', value: 'SHIPPING' });
  const quantity = watch('quantity');

  return (
    <form onSubmit={handleSubmit(onDone)}>
      <h3 className="mt-0 mb-5 font-heading text-2xl font-bold">
        Item details
      </h3>
      <Controller
        name="category"
        rules={{ required: 'Please, select an option' }}
        control={control}
        render={(props) => (
          <Select {...props} label="Product type" options={categoriesOptions} />
        )}
      />
      <Controller
        name="name"
        control={control}
        rules={{
          validate: combineValidators(
            validators.required({
              text: 'Please, enter the name',
            }),
            validators.maxLength({ maxLength: 300 }),
            validators.latinText()
          ),
        }}
        render={(props) => <Input {...props} label="Name of the product" />}
      />
      <Controller
        control={control}
        name="price"
        rules={{ required: 'Please, enter the price' }}
        render={(fieldProps) => (
          <InputMoney
            label="Price"
            currencyInValue
            precision={2}
            max={999999}
            {...phMoneyProps}
            {...fieldProps}
          />
        )}
      />
      <Controller
        name="quantity"
        rules={{
          required: 'Please, enter the number',
        }}
        control={control}
        render={(props) => (
          <InputCount label="Number of items" min={1} {...props} />
        )}
      />
      {allowsUsedItems && (
        <Controller
          name="isUsed"
          control={control}
          render={(fieldProps) => (
            <Checkbox {...fieldProps}>
              {plural(+quantity, 'Used\u00A0item', 'Used\u00A0items')}
            </Checkbox>
          )}
        />
      )}
      <Button type="submit" wide>
        Done
      </Button>
    </form>
  );
};
